import { reactive } from "vue"
import { defineStore } from "pinia"
import dgkServices from "@/common/services/DgkServices"
import { TableSortingOrder, ITableColumn } from "@/components/AppTable/ITable"
export interface IntAssetsData {
    assets: any[]
    selectedAsset: any
    page: number
    size: number
    total: number
    searchText: string
    isLoading: boolean
    sorting: {
      field: string
      type: TableSortingOrder
    },
    columns?: ITableColumn[]
}

export type PaginationButtonType = "NEXT" | "PREVIOUS" | "FIRST" | "LAST";

function getInitialState (): IntAssetsData {
  return {
      assets: [],
      selectedAsset: null,
      page: 1,
      size: 5,
      total: 0,
      searchText: '',
      isLoading: false,
      sorting: {
        field: 'name',
        type: TableSortingOrder.DESCENDING,
      },
      columns: [{
        field: "correlationId",
        title: "Process id",
        isSortable: true
      },
      {
        field: "connectorUrl",
        title: "Provider URL",
        isSortable: true
      },
      {
        field: "startDate",
        title: "Start Date",
        isSortable: false,
        width: "150px"
      },
      {
        field: "endDate",
        title: "End Date",
        isSortable: false,
        width: "150px"
      },
      {
        field: "status",
        title: "Status",
        isSortable: false,
        width: "200px"
      },
      {
        field: "actions",
        title: "Actions",
        isSortable: false
      }
    ]
  }
}

export const useUploadHistoryStore = defineStore("useUploadHistoryStore", () => {
  const historyData = reactive<IntAssetsData>(Object.assign({}, getInitialState()))

  const resetStore = () => {
    Object.assign(historyData, getInitialState())
  }

  const fetchUploadHistory = async () => {
    historyData.isLoading = true
    try {
      const payload = {
        correlationId: "",
        connectorId: "",
        querySpec: {
          page: historyData.page,
          size: historyData.size
        }
      }
      const { data } = await dgkServices.fetchAssetsUploadHistory(payload)
      historyData.assets = data.result.items
      historyData.total = data.result.total
    } catch (error) {
      console.error("Failed to fetch assets:", error);
      historyData.assets = []
    } finally {
      historyData.isLoading = false
    }
  }
  
  const updatePage = (newPage: number) => {
    if (newPage < 0) {
      newPage = 0;
    } else if (newPage >= historyData.total) {
      newPage = historyData.total - 1;
    }
    historyData.page = newPage;
  };

  const setPageDirection = (direction: PaginationButtonType) => {
    switch (direction) {
      case 'NEXT':
        updatePage(historyData.page + 1);
        break;
      case 'PREVIOUS':
        updatePage(historyData.page - 1);
        break;
      case 'FIRST':
        updatePage(0);
        break;
      case 'LAST':
        updatePage(historyData.total - 1);
        break;
      default:
        console.error('Unknown pagination button type:', direction);
    }
  }

  return {
    historyData,
    resetStore,
    fetchUploadHistory,
    setPageDirection
  }
})